import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import { placeholder } from '../../assets/placeholder';
import ImageS3Upload from '../../components/ImageS3Upload';
import { addEquipment, getEquipment, removeEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import dayjs from 'dayjs';
import useApiService from '../../hooks/useApiService';
import { Divider } from 'primereact/divider';
import {
  CircleCancelFill,
  CircleCheckFill,
  DoNotDisturbCircleFill,
  Star
} from '../../assets/icons/index';
import { useS3Service } from '../../hooks/useS3Service';
import { Toast } from 'primereact/toast';
import { PTOListUpdate } from '../../service/ptoService';

interface TaskPtoView {
  "id": number,
  "created_by": string,
  "created_by_signature_s3": string,
  "client": string,
  "site": string,
  "topic": number,
  "overall_rating": number,
  "employee": string,
  "employee_signature_s3": string,
  "employee_signature_s3_key": string,
  "questions": {
    "value": string,
    "comment": string,
    "question": string,
  }[],
  "comments": string,
  "completed": true,
  "created_at": string,
  "updated_at": string,
  "deleted_at": string,
  "employee_fullname": string,
  "created_by_fullname": string,
  "client_name": string,
  "topic_name": string,
  "site_name": string
}



export default function TaskPtoView(modalProps: any) {

  const id = modalProps?.id;
  const employeeId = modalProps?.employeeId;

  const [createdBySignature, setCreatedBySignature] = React.useState<string | null>(null);
  const [employeeSignature, setEmployeeSignature] = React.useState<string | null>(null);
  const [documentSignaturesClicked, setDocumentSignaturesClicked] = React.useState(false);
  const toast = React.useRef(null as any);

  const { getS3Url } = useS3Service();

  const { data, loading, error } = useApiService<TaskPtoView>({
    method: "GET",
    url: `pto-task/${id}`,
    apiName: "core",
    onSuccess: async record => {
      if (record.created_by_signature_s3) {
        const signatureUrl = await getS3Url(record.created_by_signature_s3);
        setCreatedBySignature(signatureUrl);
      }
      if (record.employee_signature_s3) {
        const signatureUrl = await getS3Url(record.employee_signature_s3);
        setEmployeeSignature(signatureUrl);
      }
    },
  });

  async function signatureClicked() {
    if (data?.employee !== employeeId) {
      toast.current.show({ severity: 'error', summary: 'You are not allowed to sign this document', life: 3000 });
      return;
    }
    if (!data?.employee_signature_s3_key) {
      toast.current.show({ severity: 'error', summary: 'Employee has no signature. Set under Employee profile before signing', life: 3000 });
      return;
    }
    const signatureUrl = await getS3Url(data?.employee_signature_s3_key);
    setEmployeeSignature(signatureUrl);
    setDocumentSignaturesClicked(true);
  }

  async function Submit() {
    if (!employeeSignature) {
      toast.current.show({ severity: 'error', summary: 'Employee has not signed yet', life: 3000 });
      return;
    }
    let updateDetails: any = {
      employee_signature_s3: data?.employee_signature_s3_key,
    };
    modalProps.setGlobalLoading(true);
    PTOListUpdate(id, updateDetails).then((r: any) => {
      toast.current.show({ severity: 'success', summary: 'PTO Submitted Successfully', life: 3000 });
      modalProps.setVisible(false);
      modalProps.setGlobalLoading(false);
      modalProps.setReload(!modalProps.reload);
    }).catch((error) => {
      toast.current.show({ severity: 'error', summary: 'Failed to Submit PTO', life: 3000 });
      modalProps.setGlobalLoading(false);
    })
  }

  console.log("TaskPtoView data == ", data);

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Date & Time</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={data?.created_at ? dayjs(data?.created_at).format("YYYY-MM-DD") : ""} type="text" readOnly className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Site/Project</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={data?.site_name} type="text" readOnly className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Task Observed</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={data?.topic_name} type="text" readOnly className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Observer</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={data?.created_by_fullname} type="text" readOnly className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Person Observed</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputText value={data?.employee_fullname} type="text" readOnly className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>
      </Grid>

      <Divider align="center">
        <label>Observation Checklist</label>
      </Divider>

      <Grid container spacing={2} style={{ marginTop: 10 }}>
        {data?.questions?.map((question, index) => (
          <Grid item xs={6} key={index}>
            <FormControl sx={{ flexGrow: 1 }}>
              <FormLabel>{question.question}</FormLabel>
              <InputText value={question.value} readOnly className="p-inputtext-sm PrimeSmallInput" />
              {question.comment && <InputText value={question.comment} readOnly className="p-inputtext-sm PrimeSmallInput" style={{ marginTop: 10 }} />}
            </FormControl>
          </Grid>
        ))}
      </Grid>

      <Divider align="center">
        <label>Overall Rating and Comments</label>
      </Divider>

      <Grid container spacing={2} style={{ marginTop: 10 }}>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Overall Rating</FormLabel>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {[1, 2, 3, 4, 5].map(rating => {
                return (
                  <div key={rating}>
                    <Star
                      width={32}
                      height={32}
                      fill={
                        data?.overall_rating !== undefined &&
                          rating <= data.overall_rating
                          ? "#fad502"
                          : "#aeaeae"
                      }
                    />
                  </div>
                );
              })}
            </div>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Comments</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputTextarea value={data?.comments} readOnly className="p-inputtext-sm PrimeSmallInput" />
            </FormControl>
          </FormControl>
        </Grid>
      </Grid>

      <Divider align="center">
        <label>Signatures</label>
      </Divider>

      <Grid container spacing={2} style={{ marginTop: 10 }}>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Observer Signature</FormLabel>
            {createdBySignature && (
              <img
                style={{ width: 230 }}
                src={createdBySignature}
                alt="Employee Signature"
              />
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>Employee Signature</FormLabel>
            {employeeSignature ? (
              <img
                style={{ width: 230 }}
                src={employeeSignature}
                alt="Employee Signature"
              />
            ) : (
              <div
                className="signature-image-container"
                style={{
                  height: "80px",
                  width: "250px",
                  border: "1px dashed #ccc",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: documentSignaturesClicked ? "transparent" : "#f5f5f5",
                  cursor: data?.employee !== employeeId ? "no-drop" : "pointer",
                  margin: "5px 0"
                }}
                onClick={() => signatureClicked()}
              >
                <span>Click to add signature</span>
              </div>
            )}
          </FormControl>
        </Grid>
      </Grid>



      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Submit" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={Submit} /> :
        </CardActions>
      </CardOverflow>
      <Toast ref={toast} />
    </React.Fragment>
  );
}